module.exports = __webpack_public_path__ + "img/lg_ring_g_l_null_1@2x.5979ae2e.png";